import React from 'react'

const DlpIcon = ({ name, size = 30, color = 'rgb(32, 31, 31)' }) => (
    <span className="material-symbols-rounded" style={{ fontSize: `${size}px`, color }}>
        {name}
    </span>
)

export default DlpIcon
